import React, { useState } from "react";
import { toast } from "react-toastify";
import Table from "../../../../components/elements/table/Table";
import { setTitle } from "../../../../helpers/MetaTag";
import { handleFilterChange } from "../../../../helpers";
import DeleteModal from "../../../../components/common/DeleteModal";
import { useDebounce } from "../../../../hooks/useDebounce";
import LimitSelect from "../../../../components/elements/LimitSelect";

// import { useGetPermission } from "../../hooks/useGetPermission";
import Search from "../../../../components/form/Search";
import Button from "../../../../components/form/Button";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { transactionDelete, transactionList } from "../../../../services/transactionService";
import dayjs from "dayjs";
import ManageTransactionDrawer from "../../../../components/sections/admin/Transaction/Drawer/ManageTransactionDrawer";
import Badge from "../../../../components/elements/Badge";
import { PAYMENT_METHOD } from "../../../../components/constant/constant";
import PaymentMethod from "../../../../components/common/PaymentMethod";
import { postStatusChange } from "../../../../services/postService";
import DatePicker from "../../../../components/form/DatePicker";

const Transaction = ({ userId = null, isSubscriptionDetails = false, subscriptionId = null }) => {
  setTitle("Transaction");
  //   const { permission, status } = useGetPermission("faq");

  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });

  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });

  const { data, isLoading, updateData, isFetching } = useQuery({
    queryKey: ["transaction", filters, search, subscriptionId,dateRange],
    queryFn: async () => {
      const res = await transactionList({
        ...filters,
        ...(search && { keyword: search }),
        ...(userId && { userId }),
        ...(dateRange.startDate && {
                  startDate: dayjs(dateRange.startDate).format("YYYY-MM-DD"),
                }),
                ...(dateRange.endDate && {
                  endDate: dayjs(dateRange.endDate).format("YYYY-MM-DD"),
                }),
        ...(subscriptionId && { subscriptionId: subscriptionId }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  //   FAQ status change handler =================>
  const { mutate: statusChangeHandler, isPending: statusChangeInPending } = useMutation({
    mutationFn: async ({ id, status }) => {
      queryClient.setQueryData(["transaction", filters, search], (state) => {
        if (state) {
          let stateData = JSON.parse(JSON.stringify(state?.data));
          stateData = (stateData || []).map((elm) => (elm?._id === id ? { ...elm, status: elm?.status === 1 ? 2 : 1 } : elm));
          return { ...state, data: stateData };
        }
      });
      const res = await postStatusChange({
        ids: id,
        status,
        type: "transaction",
      });
      return { res, payload: { id, status } };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status !== 200) {
        queryClient.setQueryData(["transaction", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = (stateData || []).map((elm) => (elm?._id === payload?.id ? { ...elm, status: elm?.status === 1 ? 2 : 1 } : elm));
            return { ...state, data: stateData };
          }
        });
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const payment_status = {
    completed: {
      label: "completed",
      class: "bg-green-100 text-green-700 border border-green-200",
    },
    failed: {
      label: "failed",
      class: "bg-red-100 text-red-700 border border-red-200",
    },
    pending: {
      label: "pending",
      class: "bg-yellow-100 text-yellow-700 border border-yellow-200",
    },
    refunded: {
      label: "refunded",
      class: "bg-amber-100 text-amber-700 border border-amber-200",
    },
  };

  const tableHeadData = [
    ...(userId
      ? []
      : [
          {
            _id: 2,
            name: "Name",
            align: "left",
          },
          {
            _id: 3,
            name: "Email",
            align: "left",
          },
        ]),
        
    {
      _id: 4,
      name: "Amount",
      align: "left",
    },
    {
      _id: 28,
      name: "For",
      align: "left",
    },
    {
      _id: 9,
      name: "Date",
      align: "left",
    },
    {
      _id: 10,
      name: "Payment Method",
      align: "left",
    },
    {
      _id: 11,
      name: "Payment Status",
      align: "left",
    },
    {
      _id: 13,
      name: "Action",
      align: "left",
    },
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        ...(userId?[]:[
          {
          _id: 2,
          type: "user",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.userData?.firstName + " " + item?.userData?.lastName || "-",
          image: item?.userData?.image?.url,
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.userData?.email || "-",
        },
        ]),
        
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: "$" + "" + item?.amount || "-",
        },
        {
          _id: 29,
          type: item?.planDetail?"imageWithText":"text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.planDetail?item?.planDetail?.content?.en?.title || "-":"N/A",
          ...(item?.planDetail&&{image:item?.planDetail?.image?.url})
        },
        {
          _id: 9,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.createdAt ? dayjs(item?.createdAt).format("DD MMM, YYYY") : "-",
        },
        {
          _id: 10,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: <PaymentMethod type={"Stripe"} />,
        },
        {
          _id: 11,
          type: "text",
          align: "left",
          cellClass: "!min-w-[50px]",
          data: (
            <Badge
              customColor={payment_status[item?.status]?.class || ""}
              label={item?.status|| "-"}
              className="!rounded-full !h-6 !max-w-[120px]"
            />
          ),
        },
        {
          _id: 12,
          type: "action",
          align: "left",
          cellClass: "w-[5%]",
          actionData: [
            // {
            //   _id: 1,
            //   name: "Edit",
            //   icon: "fa-regular fa-pen-to-square",
            //   onClick: () => {
            //     setModalOpen({ isOpen: true, data: item });
            //   },
            // },
            // {
            //   _id: 2,
            //   name: "Download Receipt",
            //   icon: "fa-regular fa-download",
            //   onClick: () => {
            //     handleDownloadReceipt(item);
            //     // navigate(`/admin/donations/pdf`, {
            //     //   state: {
            //     //     data: item,
            //     //     type: "DonationReciptPdf",
            //     //     fileName: `Receipt-${item?.invoiceId || "N/A"}.pdf`,
            //     //   },
            //     // });
            //   },
            // },
            // {
            //   _id: 3,
            //   name: "Add Transaction",
            //   icon: "fa-regular fa-hand-holding-circle-dollar",
            //   onClick: () => {
            //     setModalOpen({ isOpen: true, data: item });
            //   },
            // },
            {
              _id: 4,
              name: "Delete",
              icon: "fa-regular fa-trash-can",
              standout: true,
              onClick: () => {
                setDeleteModal({
                  isOpen: true,
                  data: item,
                });
              },
            },
          ],
        },
      ],
    };
  });

  // Table Body Data =====================>
  const tableDataForSubscription = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: "$" + "" + item?.amount || "-",
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.categoryType || "-",
        },
        {
          _id: 9,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.createdAt ? dayjs(item?.createdAt).format("DD MMM, YYYY") : "-",
        },
        {
          _id: 10,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: <PaymentMethod type={item?.paymentMethod} />,
        },
        {
          _id: 11,
          type: "text",
          align: "left",
          cellClass: "!min-w-[50px]",
          data: (
            <Badge
              customColor={payment_status[item?.paymentStatus]?.class || ""}
              label={item?.paymentStatus || "-"}
              className="!rounded-full !h-6 !max-w-[100px]"
            />
          ),
        },
      ],
    };
  });

  const tableHeadDataForSubscription = [
    {
      _id: 4,
      name: "Amount",
      align: "left",
    },
    {
      _id: 9,
      name: "Date",
      align: "left",
    },
    {
      _id: 10,
      name: "Payment Method",
      align: "left",
    },
    {
      _id: 11,
      name: "Payment Status",
      align: "left",
    },
  ];

  // add or edit FAQ =================>
  function faqManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          queryClient.setQueryData(["transaction", filters, search], (state) => {
            if (state) {
              let stateData = JSON.parse(JSON.stringify(state?.data));
              stateData = [...stateData, res?.data];
              return { ...state, data: stateData };
            }
          });
          if (data?.metadata?.totalDocs > filters?.limit) {
            queryClient.invalidateQueries(["transaction", filters, search]);
          }
        } else {
          setFilters((pre) => ({ ...pre, page: 1 }));
        }
      }
      if (res?.status === 200) {
        queryClient.setQueryData(["transaction", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = stateData?.map((item) => (item?._id === res?.data?._id ? { ...item, ...res?.data } : item));
            return { ...state, data: stateData };
          }
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries(["transaction", filters, search]);
        }
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message || res?.error);
    }
  }

  //   FAQ delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await transactionDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return { res, payload: Array.isArray(payload) ? payload : [payload] };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        setSelectedItems([]);
        queryClient.setQueryData(["transaction", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = (stateData || [])?.filter((item) => !payload?.includes(item?._id));
            return { ...state, data: stateData };
          }
        });

        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries(["transaction", filters, search]);
        }
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        {!userId ? (
          <div className="font-bold text-lg xl:text-3xl text-primary">Transaction Management</div>
        ) : (
          <div className="font-bold text-xl text-salte-500">All Transaction</div>
        )}

        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 1, setFilters);
              }}
            />
          </div>
          <div className="w-60">
          <DatePicker
            renge={true}
            placeholder="Pick date range"
            value={dateRange}
            onChange={(val) => {
              setDateRange(val);
              setFilters((pre) => ({ ...pre, page: 1 }));
            }}
          />
        </div>
          {/* <div className="relative">
            <Button
              buttonClasses={
                "!bg-transparent border border-transparent !h-10 hover:!bg-primary/10 hover:!border-primary/10"
              }
              buttonLabel={"Create New"}
              buttonLabelClasses={"font-medium !text-sm text-primary"}
              buttonFunction={() => setModalOpen({ isOpen: true, data: null })}
            />
          </div> */}
        </div>
      </div>

      <Table
        tableHeadData={isSubscriptionDetails ? tableHeadDataForSubscription : tableHeadData}
        tableData={isSubscriptionDetails ? tableDataForSubscription : tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        isFetching={isFetching}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />

      <ManageTransactionDrawer
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={faqManageResponse}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
};

export default Transaction;
